// Twitch box art URLs (jtvnw `ttv-boxart`) embed the requested size as `-WxH.ext`. The
// list serializer serves a small 280x320 variant, which looks blurry full-bleed. Bump the
// size in the URL (Twitch's CDN resizes on demand). No-op for any other URL.
export const upscaleBoxArt = (url, size = '1080x1440') => {
    if (!url || !url.includes('ttv-boxart')) {
        return url;
    }
    return url.replace(/-\d+x\d+(\.[a-z0-9]+)/i, `-${size}$1`);
};
// For the hero, use the drop's own promotional art: `images` holds the uploaded assets in the
// order the publisher added them, so the first one is the landscape banner they lead with. Falls
// back to the primary image (box art) for a drop that brought no art of its own.
export const pickHeroImage = (drop) => {
    var _a, _b;
    return (_b = (_a = drop.images) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : drop.image;
};
